<div class="d-flex flex-column justify-content-center">
  <h3 mat-dialog-title class="text-center">{{title}}</h3>
  <div mat-dialog-content class="text-center" *ngIf="body">
    {{body}}
  </div>
  <div mat-dialog-actions class="w-100 justify-content-center">
    <button mat-button (click)="dialogRef.close()" data-cy="confirmation-no">{{optionCancel}}</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial data-cy="confirmation-yes">{{optionConfirm}}</button>
  </div>
</div>
